import React, {
  useEffect,
  useState,
} from 'react';

import {
  Col,
  Container,
  Row,
} from 'react-bootstrap';

import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import useLayout from 'hooks/useLayout';
import useCustomLayout from 'hooks/useCustomLayout';
import { useWindowSize } from 'hooks/useWindowSize';
import useMenuStatusWatcher from 'hooks/useMenuStatusWatcher';

import {
  MENU_BEHAVIOUR,
  MENU_PLACEMENT,
} from 'constants.js';
import StaffNav from './nav/StaffNav';

const LayoutStaffPortal = ({
  children,
  staffView = 'dashboard',
  headerState = '',
}) => {
  useLayout();
  useMenuStatusWatcher();

  useCustomLayout({
    useSidebar: false,
    placement:
      MENU_PLACEMENT.Horizontal,
    behaviour:
      MENU_BEHAVIOUR.Pinned,
  });

  // @ts-ignore
  const { themeValues } = useSelector((state) => state.settings);

  const lgBreakpoint =
    parseInt(
      themeValues?.lg?.replace(
        'px',
        '',
      ) || '992',
      10,
    );

  const { width } =
    useWindowSize();

  const [
    isLgScreen,
    setIsLgScreen,
  ] = useState(false);

  const { pathname } =
    useLocation();

  useEffect(() => {
    if (!width) {
      return;
    }

    if (
      width >=
      lgBreakpoint
    ) {
      if (!isLgScreen) {
        setIsLgScreen(
          true,
        );
      }
    } else if (
      isLgScreen
    ) {
      setIsLgScreen(
        false,
      );
    }

    // eslint-disable-next-line
  }, [
    width,
    lgBreakpoint,
  ]);

  useEffect(() => {
    const html =
      document.documentElement;

    html.setAttribute(
      'data-tabulator',
      staffView,
    );

    if (headerState) {
      html.setAttribute(
        'data-header',
        headerState,
      );
    } else {
      html.removeAttribute(
        'data-header',
      );
    }

    return () => {
      html.removeAttribute(
        'data-tabulator',
      );

      html.removeAttribute(
        'data-header',
      );
    };
  }, [
    staffView,
    headerState,
  ]);

  useEffect(() => {
    document.documentElement.click();

    window.scrollTo(
      0,
      0,
    );
  }, [pathname]);

  return (
    <>

      <StaffNav /> 
      <div className="staffPortal">
        {/* <Container> */}
          <Row className="h-100">
            <Col
              className="h-100"
              id="contentArea"
            >
              {children}
            </Col>
          </Row>
        {/* </Container> */}
      </div>

      <ToastContainer />
    </>
  );
};

export default React.memo(
  LayoutStaffPortal,
);